module.exports = __webpack_public_path__ + "static/media/uni_amsterdam.52ae4ea2.png";